<template lang="pug">
  vm-prompt(@vm-cancel="close" @vm-accept="saveRecord" @vm-close="close" vm-size="large" :vm-action-text="$t('strings.delete')" :vm-accept-text="$t('strings.accept')" :vm-cancel-text="$t('strings.cancel')" :vm-is-valid="!$v.newRecord.$invalid && fileValidate && textLength" :vm-active="isModalVisible" :vm-title='getTitle')
    vm-row.modal-container(vm-align="center" vm-type="flex" vm-justify="space-between" vm-w="12")
      vm-col(vm-justify="center", vm-align="center", vm-w=6)
        b-form-group
          uploader(v-model="fileList" :autoUpload="false" :limit="1" :title="$t('solution.icon')" @on-delete="_deleteImage")
          span.muted {{ $t('strings.help_image_size', {attribute: '64 x 64 pixeles (PNG)'}) }}
      vm-col(vm-justify="center", vm-align="center", vm-w=6)
        b-form-group
          uploader(v-model="fileList2" :autoUpload="false" :limit="1" :title="$t('solution.image')" @on-delete="_deleteImage")
          span.muted {{ $t('strings.help_image_size', {attribute: '445 x 180 pixeles'}) }}
      vm-col(vm-justify="center", vm-align="center", vm-lg=12)
        b-form-group
          vm-select(:placeholder='$t("solution.type")' v-model="newRecord.type" :label='$t("solution.type")')
            vm-select-item(:key="index" :value="item.id" :text="item.name" v-for="(item,index) in type")
      vm-col(vm-justify="center", vm-align="center", vm-lg=12 v-if="this.$route.path != '/pages/people-detail/2'")
        b-form-group
          vm-select(:placeholder='$t("solution.tab")' v-model="newRecord.tab" :label='$t("solution.tab")')
            vm-select-item(:key="index" :value="item.id" :text="item.name" v-for="(item,index) in tabs")
      vm-col(vm-justify="center", vm-align="center", vm-lg=12 v-if="this.$route.path != '/pages/people-detail/2'")
        b-form-group
          vm-select(:placeholder='$t("solution.section")' v-model="newRecord.section" :label='$t("solution.section")')
            vm-select-item(:key="index" :value="item.id" :text="item.name" v-for="(item,index) in sections")
      vm-col(vm-justify="center", vm-align="center", vm-w=12)
        b-form-group
          vm-tabs
            vm-tab(vm-label='Español')
              vm-col.mt-1(vm-justify="center", vm-align="center", vm-w=12)
                b-form-group
                  vm-input(autofocus :placeholder='$t("solution.title")' maxLength="45" :danger-text="$t('validation.required', { attribute: $t('solutions.title') })" v-model="newRecord.traductions[0].title" :label='$t("solution.title")')
              vm-col(vm-justify="center", vm-align="center", vm-w=12)
                b-form-group
                vue-editor(v-model="newRecord.traductions[0].text")
            vm-tab(vm-label='Ingles')
              vm-col.mt-1(vm-justify="center", vm-align="center", vm-w=12 class="editor__wrapper")
                b-form-group
                  vm-input(autofocus :placeholder='$t("solution.title")' v-model="newRecord.traductions[1].title" :label='$t("solution.title")')
              vm-col(vm-justify="center", vm-align="center", vm-w=12 class="editor__wrapper")
                b-form-group
                  ckeditor(v-model="newRecord.traductions[1].text" maxLength="750" :editor="editor" :config="editorConfig")</template>

<script>
import ModalMixin1 from '@/mixins/ModalMixin1'
import { required } from 'vuelidate/lib/validators' // Ver documentacion
import { createNamespacedHelpers } from 'vuex'
import Uploader from 'vux-uploader-component'
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
const { mapGetters, mapActions } = createNamespacedHelpers('Solutions')

export default {
  name: 'ModalSolutions',
  components: {
    Uploader
  },
  mixins: [ModalMixin1],
  props: {
    newRecord: {
      type: Object,
      default: () => {}
    },
    isAdd: {
      default: true,
      type: Boolean
    },
    tab: {
      default: true,
      type: Boolean
    }
  },
  data: () => ({
    editor: ClassicEditor,
    editorData: '<p>Content of the editor.</p>',
    editorConfig: {
      placeholder: 'Descripción de la solución',
      toolbar: [ 'bold', 'italic', '|', 'link', '|' ]
    },
    fileList: [],
    fileList2: [],
    type: [
      {
        id: 1,
        name: 'solution'
      },
      {
        id: 2,
        name: 'special risks'
      }
    ],
    tabs: [
      {
        id: 1,
        name: 'SEGUROS'
      },
      {
        id: 2,
        name: 'FIANZAS'
      }
    ],
    sections: [
      {
        id: 1,
        name: 'Sección 1'
      },
      {
        id: 2,
        name: 'Sección 2'
      }
    ]
  }),
  validations () {
    return {
      newRecord: {
        type: {
          required
        }
      }
    }
  },
  computed: {
    ...mapGetters(['isModalVisible']),
    fileValidate () {
      if (this.isAdd) {
        return this.fileList.length > 0 && this.fileList2.length > 0
      }
    },
    textLength () {
      return this.newRecord.traductions[0].text.length > 0 && this.newRecord.traductions[0].title.length > 0
    },
    getTitle () {
      return this.isAdd ? this.$t('solution.add') : this.$t('solution.edit')
    }
  },
  watch: {
    isModalVisible (flag) {
      if (flag && this.newRecord.icon && this.newRecord.image) {
        this.fileList.push({ url: this.newRecord.icon, name: this.newRecord.id })
        this.fileList2.push({ url: this.newRecord.image, name: this.newRecord.id })
      } else {
        this.fileList = []
        this.fileList2 = []
      }
    }
  },
  methods: {
    ...mapActions([
      'addSolution',
      'updateSolution',
      'setModalVisible',
      'isModalSolutionVisible',
      'addSolution',
      'updateSolution'
    ]),
    async saveRecord () {
      this.newRecord.traductions[1].lang = 'en'
      if (this.isAdd) {
        this.newRecord.icon = this.fileList[0].blob
        this.newRecord.image = this.fileList2[0].blob
        if (this.newRecord.traductions[1].title.length === 0) this.newRecord.traductions[1].title = this.newRecord.traductions[0].title
        if (this.newRecord.traductions[1].text.length === 0) this.newRecord.traductions[1].text = this.newRecord.traductions[0].text
        await this.addSolution({ data: this.newRecord, id: this.$route.params.id })
      } else {
        if (this.fileList[0].blob !== this.newRecord.icon && this.fileList.length > 0) this.newRecord.iconFile = this.fileList[0].blob

        if (this.fileList2[0].blob !== this.newRecord.image && this.fileList2.length > 0) this.newRecord.imageFile = this.fileList2[0].blob

        await this.updateSolution({ data: this.newRecord })
      }
    }
  }
}
</script>

<style lang="css">
.modal-container {
  max-height: 450px;
  overflow-y: scroll;
}
.mt-1 {
  margin-top: 10px;
}
.editor__wrapper {
  position: relative;
}

.ck.ck-balloon-panel {
  z-index: 100000 !important;
}
</style>
